// extracted by mini-css-extract-plugin
export default {"container":"_1BQgu","comments":"_2d9QF"};